import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import ProtectedRoute from 'core/auth/protected-route.component';
import { AppLayout } from 'layout';
import { switchRoutes } from './core/routes/routes';

const LandingScene = React.lazy(() => import('scenes/landing/landing.scene'));
const ErrorScene = React.lazy(() => import('scenes/error/error.scene'));

const router = createBrowserRouter([
  {
    path: switchRoutes.root,
    element: <AppLayout />,
    errorElement: <ErrorScene />,
    children: [
      {
        path: switchRoutes.root,
        element: (
          <ProtectedRoute>
            <LandingScene />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);
export const AppRouter: React.FC = () => <RouterProvider router={router} />;
